define('modules/editor/collections/page_styles',['require','exports','module','backbone'],function(require, exports, module) {
  "use strict";
  var Backbone = require("backbone");

  /* This "element" is particular because it's related directly
  with the overall Page model. It has no visual representation but
  should be included in the serialization in order to use these CSS
  styles in Preview and Published states */
  var StyleElement =  Backbone.Model.extend({
    defaults: {
      name: "",
      content: ""
    }
  });

  module.exports = Backbone.Collection.extend({
    model: StyleElement,
    addItem: function(){
      var newItem = new StyleElement({
        name: "CSS " + (this.length+1)
      });
      this.add(newItem);
      return newItem;
    },
    showHelp: function(e){
       var $this = $(e.target).parent();
       var url = $this.find('#stylesURLHelp').text();
       $this.attr('href', url);
    },
    getCorreoDirect: function() {
      return this.findWhere({ name: "CorreoDirect" });
    },
    toggleCorreoDirectStyles: function(value) {
      value = value !== undefined ? value : !this.getCorreoDirect();
      return value ? this.addCorreoDirectStyles() : this.removeCorreoDirectStyles();
    },
    addCorreoDirectStyles: function() {
      if (!this.getCorreoDirect()) {
        this.add({
          name: "CorreoDirect",
          isTag: true,
          content: '<link rel="stylesheet" href="//clients.landings.mdirector.com/correodirect/sponsors.css"/>'
        });
      }
    },
    removeCorreoDirectStyles: function() {
      this.remove(this.getCorreoDirect());
    }
  },
  {
    fromJSON: function(json){
      return new module.exports(json);
    }
  });

});

